import React from "react";

export default function SkeletonGridCard() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2  xl:grid-cols-3">
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-row gap-x-3 border-gray-300 p-3 shadow-md bg-white min-h-[120px] animate-pulse">
        <div className="p-1 mt-1 rounded-full w-8 h-8 md:w-10 md:h-10 bg-gray-200"></div>
        <div className="flex flex-1 flex-col text-xs sm:text-sm">
          <span className="font-poppins text-sm sm:text-base font-semibold h-4 bg-gray-200 w-1/2"></span>
          <p className="text-justify flex-1 w-full line-clamp-2 leading-tight mt-2 h-8 bg-gray-200"></p>
          <div className="mt-2 flex flex-row gap-x-2 justify-end">
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
            <button className="px-2 h-4 bg-gray-200 w-14"></button>
          </div>
        </div>
      </div>
    </div>
  );
}
